<div class="portfolio-page-container">
    <mat-card>
        <h3 class="warning" *ngIf="!isSynced">
          The Node is not synced and the balance may be incorrect.
        </h3>
        <div class="wallet-bootstrap-status" *ngIf="walletBootstrapStatus">
          {{ walletBootstrapStatus }}
        </div>
        <mat-card-header>Balance</mat-card-header>
        <div class="portfolio-toolbar">
          <mat-checkbox [(ngModel)]="hideZeroBalances">Hide 0 balances</mat-checkbox>
        </div>
        <button mat-raised-button (click)='newAddress()' class='new-address-buttton' [disabled]="!isAbleToRpc">New Address</button>
        <mat-card-content>
            <mat-table [dataSource]="coinBalance" *ngIf='coinBalance'> 
              
            <ng-container matColumnDef="attestation">
              <mat-header-cell *matHeaderCellDef>Attestation</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <ng-container [ngSwitch]="getAddressAttestationStatus(element.address)">
                  <mat-icon 
                    *ngSwitchCase="'ATTESTED'" 
                    (click)="selfAttestate(element.address)">
                    check
                  </mat-icon>
                  <mat-icon 
                    *ngSwitchCase="'NOT_ATTESTED'" 
                    (click)="selfAttestate(element.address)">
                    fingerprint
                  </mat-icon>
                  <mat-icon 
                    *ngSwitchCase="'PENDING'" 
                    (click)="selfAttestate(element.address)">
                    timelapse
                  </mat-icon>
                </ng-container>
              </mat-cell>
            </ng-container>

                <ng-container matColumnDef="address">
                    <mat-header-cell *matHeaderCellDef>Address</mat-header-cell>
                    <mat-cell
                        *matCellDef="let element"
                        [title]="element.address"
                        (dblclick)='copy(element.address)'
                    >
                        {{ element.address | shortAddress }}
                        <mat-icon
                            class='copy-icon'
                            (click)='copy(element.address)'
                            [title]="element.address"
                        >content_copy</mat-icon>
                    </mat-cell>
                </ng-container>
            
                <ng-container matColumnDef="confirmed">
                    <mat-header-cell *matHeaderCellDef>Confirmed</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{ formatBalance(element?.confirmed) }} </mat-cell>
                </ng-container>
        
                <ng-container matColumnDef="unconfirmed">
                    <mat-header-cell *matHeaderCellDef>Unconfirmed</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{ formatBalance(element?.unconfirmed) }} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="tokens">
                    <mat-header-cell *matHeaderCellDef>Tokens</mat-header-cell>
                    <mat-cell *matCellDef="let element" [title]="element.tokenSummary">
                        {{ element.tokenSummary }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                    <mat-cell *matCellDef="let element"> 
                        <span class='span-button' (click)="openDialog('deposit', element.address, -1)">Receive</span> 
                        <span> | </span>
                        <span class='span-button' (click)="openDialog('withdraw', element.address, -1)">Send</span>
                        <span> | </span>
                        <span class='span-button' (click)="openTokenizeDialog(element.address, element.confirmed)">Mint {{ underlyingAssetLabel }}</span>
                        <span> | </span>
                        <span class='span-button' (click)="showTokens(element.address)">Show Tokens</span>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="cryptoBalanceColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: cryptoBalanceColumns;"></mat-row>
            </mat-table>
        </mat-card-content>
        <div class="selected-utxo-card" *ngIf="selectedAddress">
          <div class="selected-utxo-header">
            <span>UTXOs</span>
            <span class="selected-utxo-address" (click)="copy(selectedAddress)">{{ selectedAddress }}</span>
          </div>
          <div class="selected-utxo-summary">
            Confirmed: {{ formatBalance(selectedCoinBalance.confirmed) }}
            <span class="summary-divider">|</span>
            Unconfirmed: {{ formatBalance(selectedCoinBalance.unconfirmed) }}
            <span class="summary-divider">|</span>
            Count: {{ selectedUtxos.length }}
          </div>
          <div class="no-tokens" *ngIf="!selectedUtxos?.length">
            No UTXOs returned for selected address.
          </div>
          <mat-table [dataSource]="selectedUtxos" *ngIf="selectedUtxos?.length">
            <ng-container matColumnDef="txid">
              <mat-header-cell *matHeaderCellDef>Txid</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element?.txid || '-' }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="vout">
              <mat-header-cell *matHeaderCellDef>Vout</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element?.vout ?? 0 }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="amount">
              <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ formatBalance(element?.amount) }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="confirmations">
              <mat-header-cell *matHeaderCellDef>Confirmations</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element?.confirmations ?? 0 }}</mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="['txid', 'vout', 'amount', 'confirmations']"></mat-header-row>
            <mat-row *matRowDef="let row; columns: ['txid', 'vout', 'amount', 'confirmations'];"></mat-row>
          </mat-table>
        </div>
    </mat-card>

   <mat-card *ngIf="selectedAddress">
    <mat-card-header>Tokens Balances: <span (click)="copy(selectedAddress)">{{ selectedAddress }}</span></mat-card-header>
    <mat-card-content>
      <div class="no-tokens" *ngIf="!tokensBalances?.length">
        No available tokens for selected address!
      </div>

      <mat-table [dataSource]="tokensBalances" *ngIf='tokensBalances?.length'>

        <!-- Property ID Column -->
        <ng-container matColumnDef="propertyid">
          <mat-header-cell *matHeaderCellDef>Token Id</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element?.propertyid !== undefined ? element.propertyid : 'N/A' }}
          </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Token Name</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element?.name || '-' }}
          </mat-cell>
        </ng-container>

        <!-- Available Column -->
        <ng-container matColumnDef="available">
          <mat-header-cell *matHeaderCellDef>Available</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ formatBalance(element?.available) }}
          </mat-cell>
        </ng-container>

        <!-- Conditionally Render Reserved, Margin, Channel based on showVestingColumn -->
        <ng-container >
          <!-- Reserved Column -->
          <ng-container matColumnDef="reserved">
            <mat-header-cell *matHeaderCellDef>Reserved</mat-header-cell>
            <mat-cell *matCellDef="let element">
                {{ getReservedOrVestingValue(element) }}
            </mat-cell>
          </ng-container>

          <!-- Margin Column -->
          <ng-container matColumnDef="margin">
            <mat-header-cell *matHeaderCellDef>Margin</mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ formatBalance(element?.margin) }}
            </mat-cell>
          </ng-container>

          <!-- Channel Column -->
          <ng-container matColumnDef="channel">
            <mat-header-cell *matHeaderCellDef>Channel</mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ formatBalance(element?.channel) }}
            </mat-cell>
          </ng-container>
        </ng-container>


        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class='span-button' (click)="openDialog('deposit', selectedAddress, element.propertyid)">Receive</span>
            <span> | </span>
            <span class='span-button' (click)="openDialog('withdraw', selectedAddress, element.propertyid)">Send</span>
            <ng-container *ngIf="isProceduralReceiptRow(element)">
              <span> | </span>
              <span class="span-button" (click)="openTokenActionDialog(selectedAddress, element)">Redeem {{ underlyingAssetLabel }}</span>
            </ng-container>
          </mat-cell>
        </ng-container>

        <!-- Header Row Definition -->
        <mat-header-row *matHeaderRowDef="tokensBalanceColums"></mat-header-row>

        <!-- Data Row Definition -->
        <mat-row *matRowDef="let row; columns: tokensBalanceColums;"></mat-row>
      </mat-table>
    </mat-card-content>
  </mat-card>
</div>
